import { Menu } from '../core/models/menu';

export const MENUS: Menu[] = [
  {
    icon: 'form:document',
    label: 'menu.sales',
    id: 'salesJourney',
    subMenu: [
      {
        subLabel: 'menu.agentDelegation',
        subLink: '/agent/employer-summary',
      },
      // {
      //   subLabel: 'Product Type Summary',
      //   subLink: '/salesjourney/product-type-summary/select-product-type',
      // },
      {
        subLabel: 'menu.agentEIFFSummary',
        subLink: '/salesjourney/md-iff-summary',
      },
      {
        subLabel: 'MPF eIFF & walk-in summary',
        subLink: '/salesjourney/sales-support-summary',
      },
      {
        subLabel: 'IFF Paper Form',
        subLink: '/salesjourney/iff-paper-form/select-product-type',
      },
      {
        subLabel: 'MPF eIFF & walk-in summary',
        subLink: '/salesjourney/super-admin',
      },
      {
        subLabel: 'All eIFF Summary',
        subLink: '/salesjourney/app-paper-summary',
      },
      {
        subLabel: 'menu.wsmCaseSummaryPage',
        subLink: '/salesjourney/wsm-case-summary',
      },
      {
        subLabel: 'IFF Mismatch Dashboard',
        subLink: '/salesjourney/iff-declined-dashboard',
      },
      {
        subLabel: 'menu.roboAdvisory',
        subLink: '/robo-advisory',
      },
    ],
  },
  {
    icon: 'finance:bonus',
    label: 'menu.bonusUnit',
    subMenu: [
      {
        subLabel: 'menu.bonusUnit.maintenance',
        subLink: '/bonus-unit/maintenance-account-overview',
      },
      {
        subLabel: 'menu.bonusUnit.manulAdjust',
        subLink: '/bonus-unit/manual-adjustment',
      },
    ],
  },
  {
    icon: 'finance:transfer_of_existing_assets',
    label: 'menu.commission',
    id: 'commission',
    subMenu: [
      {
        subLabel: 'menu.apeJournal',
        subLink: '/commission/ape-journal',
      },
      {
        subLabel: 'menu.manAdjNbvRti',
        subLink: '/commission/ape-manual',
      },
      {
        subLabel: 'menu.commBatchUpload',
        subLink: '/commission/batch-upload-adjustment',
      },
      {
        subLabel: 'menu.commAdjustment',
        subLink: '/commission/adjustment',
      },
      {
        subLabel: 'menu.defaultsSale',
        subLink: '/commission/default-scale-list',
      },
      {
        subLabel: 'menu.errorLog',
        subLink: '/commission/error-log',
      },
      {
        subLabel: 'menu.commInfo',
        subLink: '/commission/pool-list',
      },
      {
        subLabel: 'menu.commJournal',
        subLink: '/commission/journal',
      },
      {
        subLabel: 'menu.commScale',
        subLink: '/commission/scale-list',
      },
      {
        subLabel: 'menu.commHold',
        subLink: '/commission/hold-on-report',
      },
      {
        subLabel: 'menu.commSchemeMaster',
        subLink: '/commission/scheme-list',
      },
      {
        subLabel: 'menu.commWithdrawal',
        subLink: '/commission/withdrawal-claw-back',
      },
    ],
  },
  {
    icon: 'people:people_2',
    label: 'menu.customers',
    subMenu: [
      {
        subLabel: 'menu.memberSearch',
        subLink: '/employee/list',
      },
      {
        subLabel: 'menu.employerSearch',
        subLink: '/employer/list',
      },
      {
        subLabel: 'menu.campaignMasterList',
        subLink: '/campaign/list',
      },
      {
        subLabel: 'menu.sqLog',
        subLink: '/employer/sq-log-master-list',
      },
      {
        subLabel: 'menu.mpf-benefit-payment',
        subLink: '/gs/benefit-payment/list',
      },
      {
        subLabel: 'menu.omBenefitPayment',
        subLink: '/ptw/benefit-payment/list',
      },
      {
        subLabel: 'menu.pushNotification',
        subLink: '/mobile-subscription/list',
      },
      {
        subLabel: 'menu.activityRecordList',
        subLink: '/employer/activity-record',
      },
    ],
  },
  {
    icon: 'general:solutions',
    label: 'menu.operationsHub',
    subMenu: [
      {
        subLabel: 'menu.agentSep',
        subLink: '/employer/agent-sep',
      },
      {
        subLabel: 'menu.announcementCenter',
        subLink: '/annuncement/announcement-center',
      },
      {
        subLabel: 'menu.auditLog',
        subLink: '/system/audit-history',
      },
      {
        subLabel: 'menu.calendar',
        subLink: '/system/calendar',
      },
      {
        subLabel: 'menu.financialJournal',
        subLink: '/payment/financial',
      },
      {
        subLabel: 'menu.paymentDetail',
        subLink: '/payment/details',
      },
      {
        subLabel: 'menu.fund-price-and-rates',
        subLink: '/employer/fund-benifit',
      },
    ],
  },
  {
    icon: 'wayfinding:library',
    label: 'menu.report',
    id: 'reportCenter',
    subMenu: [
      {
        subLabel: 'menu.agentProfile',
        subLink: '/report-center/agent-profile-list',
      },
      {
        subLabel: 'menu.amlUpload',
        subLink: '/report-center/high-risk-file-upload-center',
      },
      {
        subLabel: 'menu.reportExtraction',
        subLink: '/report-center/report-extraction',
      },
      {
        subLabel: 'Fund Price Interface Upload',
        subLink: '/fund-price-interface-upload',
      },
      {
        subLabel: 'menu.reportCommission',
        subLink: '/report-center/report-commission',
      },
      {
        subLabel: 'menu.reportMLFUB',
        subLink: '/report-center/report-mlfub',
      },
      {
        subLabel: 'menu.reportCenter',
        subLink: '/report-center',
      },
      {
        subLabel: 'Upload Center',
        subLink: '/upload-center',
      },
      {
        subLabel: 'menu.mpfTransferIn',
        subLink: '/report-center/plan-transfer-in',
      },
      {
        subLabel: 'menu.reportTvc',
        subLink: '/report-center/report-tvc',
      },
    ],
  },
  {
    icon: 'environment:building',
    label: 'menu.SHKP',
    subMenu: [
      {
        subLabel: 'menu.followTermination',
        subLink: '/termination/list',
      },
      {
        subLabel: 'menu.followEnrolment',
        subLink: '/enrolment/list',
      },
      {
        subLabel: 'menu.supervisorTermination',
        subLink: '/agent-performance/head',
      },
      {
        subLabel: 'menu.supervisorEnrolment',
        subLink: '/agent-performance-enrolment/head',
      },
      {
        subLabel: 'menu.staffTermination',
        subLink: '/agent-performance/list',
      },
      {
        subLabel: 'menu.staffEnrolment',
        subLink: '/agent-performance-enrolment/list',
      },
      {
        subLabel: 'menu.agentReassignment',
        subLink: '/shk/agent-reassignment',
      },
      {
        subLabel: 'menu.rolloverMember',
        subLink: '/shk/auto-rollover/list',
      },
      {
        subLabel: 'menu.rolloverPayment',
        subLink: '/shk/auto-rollover-payment/list',
      },
      {
        subLabel: 'menu.bankStatement',
        subLink: '/shkp/scb-statement-upload',
      },
      {
        subLabel: 'menu.benefitPayment',
        subLink: '/shkp/benefit-payment/list',
      },
      {
        subLabel: 'menu.benefitPaymentReport',
        subLink: '/report-center/payment-report-shkp',
      },
      {
        subLabel: 'menu.agentList',
        subLink: '/agentList/list',
      },
    ],
  },
  {
    icon: 'action:gear',
    label: 'menu.setting',
    subMenu: [
      {
        subLabel: 'menu.aclGroupManage',
        subLink: '/system/acl-group-list',
      },
      {
        subLabel: 'menu.roleManage',
        subLink: '/system/role-list',
      },
      {
        subLabel: 'menu.reportPermission',
        subLink: '/system/reporting-role-list',
      },
      {
        subLabel: 'menu.manageAttribute',
        subLink: '/system/attribute-list',
      },
    ],
  },
];
